export default __webpack_public_path__ + "b5ab30dea8ac3804e8c2d4907c6ab939.png";